import type { ReactNode } from "react";
import { Text, View } from "react-native";

import { LoadingIndicator } from "../primitives/LoadingIndicator";
import type { UiTheme } from "../theme";
import { makeProgressViewStyles } from "./progressViewStyles";

/** The title row over the host's session-load error, or a spinner while the
 *  sessions load (`loading`). Null once there is data: the card draws it.
 *  Shared by the Rhythm and the streak widgets. */
export function ProgressWidgetStatus({
  theme,
  titleRow,
  error,
  loading,
}: {
  theme: UiTheme;
  titleRow: ReactNode;
  error: string | null;
  loading: boolean;
}) {
  const styles = makeProgressViewStyles(theme);
  if (error === null && !loading) return null;
  return (
    <View style={styles.rhythm}>
      {titleRow}
      {error !== null ? (
        <Text style={[styles.statValue, { color: theme.palette.danger }]}>
          {error}
        </Text>
      ) : (
        <LoadingIndicator theme={theme} />
      )}
    </View>
  );
}
